// import React from 'react';
import React, { Component } from 'react';
import { BrowserRouter, Route } from "react-router-dom";
// import Admin from './components/Index';
import './components/Index';
import Login from './components/Login';
import Page from './components/Page';
import './components/LoginPage.css';
// import Book from './rujukan/Book';
// import sheet from './components/lib/SheetJs'
// import ResetPass from "./components/ResetPassword.js";

class Router extends Component {

  constructor(props) {
    super(props);
    this.state = {
      Admin: null,
      Book: null,
      SBook: null,
      Page1: null,
      MTest: null,
      Resetp: null,
    }
    this.renderPosts = this.renderPosts.bind(this);
  }

  componentDidMount() {
    this.renderPosts();
  }

  renderPosts = async () => {
    let Admin;
    let Book;
    let SBook;
    let Page1;
    let MTest;
    let Resetp;
    if (localStorage.getItem("page") == "klinik") {
      // require('./components/LoginPage.css');
      require('./styleguide.css');
      require('./components/assets/sidebar.css');
      require('./components/assets/sidebarResponsive.css');
      require('./components/header.scss');
      require('./components/page-content/dashboard.css');
      require('./components/page-content/body.scss');
      require('./components/page-content/assets/style.css');
      require('./components/page-content/assets/painscale.css');
      require('./pagemenu.css');
      Admin = await import('./components/Index');
      this.setState({
        Admin: Admin.default
      });
    } else if (localStorage.getItem("page") == "rujukan") {
      require('./rujukan/styleguide.css');
      require('./rujukan/assets/style.css');
      require('./rujukan/globals.css');
      require('./rujukan/assets/page1.css');
      require('./rujukan/assets/header.css');
      require('./pagemenu.css');
      Book = await import('./rujukan/Book');
      SBook = await import('./rujukan/SBook');
      Page1 = await import('./rujukan/Page1');
      MTest = await import('./rujukan/MasterTest');
      Resetp = await import('./rujukan/ResetPassword');
      this.setState({
        Book: Book.default,
        SBook: SBook.default,
        Page1: Page1.default,
        MTest: MTest.default,
        Resetp: Resetp.default,
        
      });
      // import SBook from "../SpecifyBook.js";
      // import Page1 from "../Page1";
      // import MasterTest from "../MasterTest";
    } else { }


  }

  render() {
    return (
      <BrowserRouter forceRefresh={true}>
        <Route path="/" exact component={Login} />
        <Route path="/admin" component={this.state.Admin ? this.state.Admin : null} />
        <Route path="/menu" component={Page} />
        <Route path="/registration" component={this.state.Book ? this.state.Book : null} />
        <Route path="/sregistration" component={this.state.SBook ? this.state.SBook : null} />
        <Route path="/pasien" component={this.state.Page1 ? this.state.Page1 : null} />
        <Route path="/admin/master-test" component={this.state.MTest ? this.state.MTest : null} />
        {/* <Route path="/sheetjs" component={sheet} /> */}
        <Route path="/reset-password" component={this.state.Resetp ? this.state.Resetp : null} />
      </BrowserRouter>
    );
  }



}


export default Router;